import { useState } from "react";
import { DateBox, RadioGroup } from "devextreme-react";
import * as actions from "../../../actions/multiSurvey";
import moment from "moment";
import React from "react";

const ExportDataFilters = (props: any) => {
  const [showExportDateFilter, setShowExportDateFilter] = useState(false);
  const {
    tierId,
    showExportForm,
    shiftDetails,
    siteLocalDate,
    surveyID,
    surveyName,
  } = props;
  const [filterDate, setFilterDate] = useState<any>({
    startDate: moment(new Date(siteLocalDate))
      .subtract(90, "days")
      .format("YYYY-MM-DD"),
    endDate: new Date(siteLocalDate),
  });

  const handleExport = () => {
    const payload: any = {
      tierID: +tierId,
      surveyID: +surveyID,
      surveyName: surveyName,
      startDate: filterDate?.startDate,
      isAll: showExportDateFilter ? false : true,
      section: props.navigationOn,
      endDate: moment(filterDate.endDate).format("YYYY-MM-DD"),
    };
    // const payload: any = {
    //     tierID: +tierId,
    //     surveyID: +surveyID,
    //     surveyName: surveyName,
    //     startDate: '2023-11-21',
    //     isAll: showExportDateFilter ? false : true,
    //     endDate: '2023-11-22',
    // };
    actions.exportMultiSurveyData(payload);
    showExportForm(false);
  };

  return (
    <div>
      <div>
        <RadioGroup
          items={[
            { id: false, text: "All" },
            { id: true, text: "Date Range" },
          ]}
          value={showExportDateFilter}
          valueExpr="id"
          displayExpr="text"
          onValueChanged={(e) => {
            setShowExportDateFilter(e.value);
          }}
          layout="horizontal"
        />
      </div>
      <div
        className="d-flex"
        style={{
          alignItems: "flex-end",
          flexWrap: "wrap",
          width: "100%",
          padding: "10px 0",
        }}
      >
        {showExportDateFilter === true && (
          <div
            style={{
              display: "flex",
            }}
          >
            <div>
              Start date:{" "}
              <DateBox
                value={filterDate.startDate}
                onValueChanged={(e) =>
                  setFilterDate((prev: any) => {
                    return { ...prev, startDate: e.value };
                  })
                }
                useMaskBehavior={true}
                type="date"
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              End date:{" "}
              <DateBox
                value={filterDate.endDate}
                onValueChanged={(e) =>
                  setFilterDate((prev: any) => {
                    return { ...prev, endDate: e.value };
                  })
                }
                type="date"
                useMaskBehavior={true}
              />
            </div>
          </div>
        )}
        <div className="cbtn">
          <button
            style={{ cursor: "pointer" }}
            onClick={handleExport}
            className={`secondary-btn ${showExportDateFilter && "btn"}`}
          >
            Export
          </button>
          <button
            onClick={() => {
              showExportForm(false);
            }}
            className="btn primary-btn"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportDataFilters;
